export const OPENAI_API_KEY =
    "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";
